// extracted by mini-css-extract-plugin
module.exports = {"root":"ImagesGrid-module--root--3qnnK","grid":"ImagesGrid-module--grid--2GueK","img":"ImagesGrid-module--img--3xviJ"};